import axios from 'axios'
import BpmOsgpoModule from '@/helpers/Modules/Product/BpmOsgpoModule'

export function useBpmScoring ({ policy, notify, scoringLoading, changeDisabled }) {
  function buildScoringPayload () {
    return {
      policy: {
        insurer: policy.insurer,
        insureds: policy.insureds,
        vehicle: policy.vehicle,
      },
    }
  }

  function checkScoring () {
    scoringLoading.value = true
    changeDisabled.value = true

    return axios
      .post('/api/v2/scoring/ogpo/contract/check', buildScoringPayload())
      .then(res => {
        if (!res.data?.result) {
          notify.error(res.data)
          return false
        }

        policy.scoring = { ...res.data }

        if (BpmOsgpoModule.Wizard.isDgpoForbidden(policy)) {
          policy.dgpo = null
        } else if (res.data.dgpo_required && !policy.dgpo) {
          policy.dgpo = BpmOsgpoModule.Dgpo.empty()

          if (res.data.warning) {
            notify.warning(res.data)
          }
        }

        return true
      })
      .catch(err => {
        notify.error(err)
        return false
      })
      .finally(() => {
        scoringLoading.value = false
        changeDisabled.value = false
      })
  }

  return {
    buildScoringPayload,
    checkScoring,
  }
}
